export default __webpack_public_path__ + "static/media/bice-vida-welcome.db29871d.png";